<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file CheckoutSavedCard.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  CheckoutSavedCard.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <div class="card-body container">
        <div class="mb-2">
            <h5 class="mb-0 h5 d-flex align-items-center">
                <i class="material-icons pr-1" aria-hidden="true">credit_card</i>
                <strong class="mr-1">Step {{step}}:</strong> <span>
                <bold-words :word="{
                        text:`Saved Card`
                        }"
                /></span>
            </h5>
            <small class="text-muted d-block">Use your saved card or choose another</small>
        </div>
        <slot></slot>
        <div v-show="show_card===true">
            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    <span>Card type:</span>
                    <span class=" d-flex justify-content-between align-items-center">
                                                        <span class="mr-2">{{ last_card_used.holder }}</span>
                                                        <i v-if="last_card_used.brand === 'Visa'"
                                                           class="fa fs-5 fa-cc-visa "></i>
                                                        <i v-else-if="last_card_used.brand === 'MasterCard'"
                                                           class="fa fs-5 fa-cc-mastercard "></i>
                                                        <i v-else-if="last_card_used.brand === 'Discovery'"
                                                           class="fa fs-5 fa-cc-discover "></i>
                                                        <i v-else-if="last_card_used.brand === 'JCB'"
                                                           class="fa fs-5 fa-cc-jcb "></i>
                                                        <i v-else class="fa fs-5 fa-credit-card "></i>
                                                    </span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    Card number: <span> <span>**** **** ****</span> <span
                        class="pl-1">{{ last_card_used.last4 }}</span></span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    Expires: <span>{{ last_card_used.exp_month }}/{{ last_card_used.exp_year }}</span>
                </li>
            </ul>
            <transition name="fade">
                <template v-if="!show_spinner">
                    <div class="d-flex justify-content-between align-content-center mt-3">
                        <BaseButton
                                type="div"
                                @click="useCard"
                        >Use this card
                        </BaseButton>
                        <BaseButton
                                type="div"
                                @click="createCard"
                                btn_type="btn-secondary"
                        >Choose another
                        </BaseButton>
                    </div>
                </template>
                <CheckoutRequestingSpinner
                        v-else
                        :show="show_spinner"
                        :width="spinner_progress"
                ></CheckoutRequestingSpinner>
            </transition>
        </div>
    </div>

</template>

<script>
    export default {
        name: "checkout-saved-card",
        props: {
            show_card:{
                type:Boolean,
                default:false
            },
            show_spinner:{
                type:Boolean,
                default:true
            },
            spinner_progress:{
                type: Number,
                default: 0
            },
            step: {
                type: Number,
                default: 1
            },
            user_auth: {
                type: Boolean,
                default: false
            },
            /**
             * @param {String} last_card_used.holder
             * @param {String} last_card_used.brand
             * @param {String} last_card_used.last4
             * @param {String} last_card_used.exp_month
             * @param {String} last_card_used.exp_year
             * @namespace {Object} last_card_used
             */
            last_card_used: {
                type: Object,
                default: {}
            },
        },
        data(){
            return {}
        },
        methods: {
            createCard() {
                this.$emit('create_card')
            },
            useCard() {
                this.$emit('use_card')
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/checkout/CheckoutSavedCard.vue